import usePointOfSale from "./usePointOfSale";
import useGlobalContext from "./useGlobalContext";
/**
 * Hook for conditions needed to show multi product components only when the experiment is running
 * and not on production environment.
 *
 * @returns boolean
 */
export default function useMultiProduct(supplyType?: string): boolean {
  const pointOfSale = usePointOfSale();
  const isUK = pointOfSale === "gb";
  const { features } = useGlobalContext();
  const isEligible = isUK && !!features["FLIGHTS_BASKET_CART_ENABLED"];

  if (supplyType) {
    const isMvpTraffic = !!(isEligible && supplyType === "MERCHANT");
    return isMvpTraffic;
  }

  return isEligible;
}
